/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getTileResults} from '../api'

 export const useQueryGetTileResults = createReactQueryHook('getTileResults', getTileResults)
